"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PickADate_1 = require("./PickADate");
require("./JQueryExtensions");
(function (w, $) {
    if (!$)
        return false;
    $.extend($.fn.pickadate.defaults, PickADate_1.PickADate.getTranslations());
    $.extend($.fn.pickatime.defaults, PickADate_1.PickADate.getTranslations());
    $.extend($.fn.clockpickerdefaults, { cleartext: PickADate_1.PickADate.getTranslations().clear, donetext: PickADate_1.PickADate.getTranslations().close });
    return true;
})(window, $);
